module.exports = __webpack_public_path__ + "img/corn_on_cob.69fbef31.jpg";